import { WeatherSettingsChangeSource } from '@fe/weather';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { Checkbox, NumericTextBox, RadioGroup } from '@progress/kendo-react-inputs';
import {
    EdrPointsColorOptions,
    IataTurbDisplayTypeOptions,
    IataTurbValueOptions,
    MinimumEdrNowcastOptions,
    MinimumIataTurbLevelOptions,
    MinimumTapsLevelOptions,
    SeverityColorPaletteOptions
} from '../settings-options';
import { useBooleanSetting, useDropdownSetting, useNumericSetting, useRadioGroupSetting } from './hooks/useSetting';
import SettingsSubSection from '../../../common/SettingsSubSection';

export default function TurbulenceSettings() {
    const iataMinLevel = useDropdownSetting(
        MinimumIataTurbLevelOptions,
        'turbulenceIcing',
        'minimumIataLevel',
        WeatherSettingsChangeSource.turbulenceIata
    );
    const minimumTaps = useDropdownSetting(
        MinimumTapsLevelOptions,
        'turbulenceIcing',
        'minimumTapsLevel',
        WeatherSettingsChangeSource.turbulenceTaps
    );
    const iataTurbValue = useRadioGroupSetting(
        IataTurbValueOptions,
        'turbulenceIcing',
        'iataTurbValue',
        WeatherSettingsChangeSource.turbulenceIata
    );
    const iataDisplayNullReports = useBooleanSetting(
        'turbulenceIcing',
        'iataDisplayNullReport',
        WeatherSettingsChangeSource.turbulenceIata
    );
    const iataNullReportColors = useRadioGroupSetting(
        EdrPointsColorOptions,
        'turbulenceIcing',
        'iataNullReportColor',
        WeatherSettingsChangeSource.turbulenceIata
    );
    const iataDisplayType = useRadioGroupSetting(
        IataTurbDisplayTypeOptions,
        'turbulenceIcing',
        'iataDisplayType',
        WeatherSettingsChangeSource.turbulenceIata
    );
    const iataSeverityPalette = useRadioGroupSetting(
        SeverityColorPaletteOptions,
        'turbulenceIcing',
        'iataSeverityPalette',
        WeatherSettingsChangeSource.turbulenceIata
    );
    const iataShowWindBarbs = useBooleanSetting('turbulenceIcing', 'iataShowWindBarbs', WeatherSettingsChangeSource.turbulenceIata);
    const iataMaxReportTime = useNumericSetting('turbulenceIcing', 'iataMaxReportTime', WeatherSettingsChangeSource.turbulenceIata);
    const iataFadeOldReports = useBooleanSetting('turbulenceIcing', 'iataFadeOldReports', WeatherSettingsChangeSource.turbulenceIata);
    const minimumEdrLevel = useDropdownSetting(
        MinimumEdrNowcastOptions,
        'turbulenceIcing',
        'minimumEdrLevel',
        WeatherSettingsChangeSource.turbulenceEdr
    );

    const applyTransparency = useBooleanSetting(
        'turbulenceIcing',
        'turbulenceApplyTransparency',
        WeatherSettingsChangeSource.turbulenceTransparency
    );

    return (
        <div className="d-flex gap-2 flex-column">
            <SettingsSubSection title="Forecast/NOWCast">
                <div>
                    <div>Minimum EDR level to display:</div>
                    <DropDownList {...minimumEdrLevel} />
                </div>

                <Checkbox {...applyTransparency} label="Apply transparency" />
            </SettingsSubSection>

            <SettingsSubSection title="IATA turbulence reports">
                <div>
                    <div>Min turbulence level to display</div>
                    <DropDownList {...iataMinLevel} />
                </div>

                <div>
                    <div>Min TAPs level:</div>
                    <DropDownList {...minimumTaps} />
                </div>

                <div className="d-flex gap-2">
                    <div>Points based on:</div>
                    <RadioGroup {...iataTurbValue} layout="horizontal" />
                </div>

                <Checkbox label="Display 0 EDR reports (heartbeats)" {...iataDisplayNullReports} />

                <div className="d-flex gap-2">
                    <div>0 EDR report color:</div>
                    <RadioGroup {...iataNullReportColors} layout="horizontal" />
                </div>

                <div>
                    <div>Display type:</div>
                    <RadioGroup {...iataDisplayType} />
                </div>

                <div>
                    <div>Severity color palette (see map legend):</div>
                    <RadioGroup {...iataSeverityPalette} />
                </div>

                <Checkbox label="Display wind barbs" {...iataShowWindBarbs} />

                <div>
                    <div>Reported within the past</div>
                    <NumericTextBox min={0} format={'0 minutes'} {...iataMaxReportTime} />
                </div>

                <Checkbox label="Fade old reports" {...iataFadeOldReports} />
            </SettingsSubSection>
        </div>
    );
}
